var module = angular.module('octopusApp.users', []);

module.config(function($stateProvider) {

    $stateProvider.state("app.signin", {
        url: '/users/sign-in',
        templateUrl:  'areas/users/views/sign-in.html',
        controller: 'SignInController',
        layout: {
            tab: 'user',
            title: 'Sign in',
            layout: "layout-blank"
        }
    });

    $stateProvider.state("app.signout", {
        url: '/users/sign-out',
        templateUrl:  'areas/users/views/sign-out.html',
        controller: 'SignOutController',
        layout: {
            tab: 'user',
            title: 'Sign in',
            layout: "layout-blank"
        }
    });

    $stateProvider.state("app.profile", {
        url: '/users/me',
        templateUrl:  'areas/users/views/profile.html',
        controller: 'ProfileController',
        layout: {
            tab: 'user',
            title: 'My profile'
        }
    });

    $stateProvider.state("app.register", {
        url: '/users/register',
        templateUrl:  'areas/users/views/register.html',
        controller: 'RegisterController',
        layout: {
            title: 'Register a user account',
            layout: 'layout-blank'
        }
    });

    $stateProvider.state("app.register.invite", {
        url: '/:invitation'
    });
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/users/users_module.js
// module id = 139
// module chunks = 1